import jsonLogic from "json-logic-js";
import { difference, filter, find, flatten, get, map, } from "lodash";

/*
 * Create path of questions based on a graph (defining branches) and current answers.
 *
 * First each block is tested to see if it's visible or not. Then for each remaining blocks we perform a similar
 * test for each of its questions.
 *
 * The resulting path will contain questions which are allowed to be displayed.
 */
const createPath = (blocks, questions, graph, context, params) => {
  const blockList = map(graph, block => find(blocks, { name: block.name }));
  const blockFilteredList = filter(blockList, block => get(params, 'blockDisplayLogic', true) ? jsonLogic.apply(get(block, 'displayLogic', true), context) : true);
  const questionIdList = flatten(map(blockFilteredList, block => get(find(graph, { name: block.name }), 'values', [])));
  const questionList = map(questionIdList, name => find(questions, { name }));
  const questionFilteredList = filter(questionList, question => get(params, 'questionDisplayLogic', true) ? jsonLogic.apply(get(question, 'displayLogic', true), context) : true);

  const path = map(questionFilteredList, question => question.name);

  return path;
};

// For a certain path, remove all discarded questions defined in the context
const filterExcludedItems = (path, ctx) => {
  const context = get(ctx, 'context', {});
  const excluded = flatten(map(context, item => get(item, 'discarded', [])));

  return difference(path, excluded);
};

// Return path generated from the current state
export default (blocks, questions, graph, context, params) => {
  const path = createPath(blocks, questions, graph, context, params);
  return filterExcludedItems(path, context);
};
